export const PROJECT_STATUSES = {
  a_chiffrer: { label: "\u00c0 chiffrer", color: "bg-zinc-500/10 text-zinc-400 border-zinc-500/20" },
  devis_envoye: { label: "Devis envoy\u00e9", color: "bg-sky-500/10 text-sky-400 border-sky-500/20" },
  attente_validation: { label: "Attente validation", color: "bg-amber-500/10 text-amber-400 border-amber-500/20" },
  commande_lancee: { label: "Commande lanc\u00e9e", color: "bg-sky-500/10 text-sky-400 border-sky-500/20" },
  en_production: { label: "En production", color: "bg-blue-500/10 text-blue-400 border-blue-500/20" },
  chez_sous_traitant: { label: "Sous-traitant", color: "bg-violet-500/10 text-violet-400 border-violet-500/20" },
  controle_qualite: { label: "Contr\u00f4le qualit\u00e9", color: "bg-amber-500/10 text-amber-400 border-amber-500/20" },
  pret_expedition: { label: "Pr\u00eat \u00e0 exp\u00e9dier", color: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20" },
  livre: { label: "Livr\u00e9", color: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20" },
  facture: { label: "Factur\u00e9", color: "bg-teal-500/10 text-teal-400 border-teal-500/20" },
  termine: { label: "Termin\u00e9", color: "bg-zinc-500/10 text-zinc-500 border-zinc-500/20" },
  bloque: { label: "Bloqu\u00e9", color: "bg-rose-500/10 text-rose-400 border-rose-500/20" },
};

export const QUOTE_STATUSES = {
  nouveau: { label: "Nouveau", color: "bg-sky-500/10 text-sky-400 border-sky-500/20" },
  en_analyse: { label: "En analyse", color: "bg-amber-500/10 text-amber-400 border-amber-500/20" },
  attente_fournisseur: { label: "Attente fournisseur", color: "bg-amber-500/10 text-amber-400 border-amber-500/20" },
  en_chiffrage: { label: "En chiffrage", color: "bg-blue-500/10 text-blue-400 border-blue-500/20" },
  devis_pret: { label: "Devis pr\u00eat", color: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20" },
  devis_envoye: { label: "Devis envoy\u00e9", color: "bg-sky-500/10 text-sky-400 border-sky-500/20" },
  relance_a_faire: { label: "Relance \u00e0 faire", color: "bg-rose-500/10 text-rose-400 border-rose-500/20" },
  gagne: { label: "Gagn\u00e9", color: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20" },
  perdu: { label: "Perdu", color: "bg-rose-500/10 text-rose-400 border-rose-500/20" },
  annule: { label: "Annul\u00e9", color: "bg-zinc-500/10 text-zinc-500 border-zinc-500/20" },
};

export const PAYMENT_STATUSES = {
  a_venir: { label: "\u00c0 venir", color: "bg-sky-500/10 text-sky-400 border-sky-500/20" },
  paye_partiellement: { label: "Pay\u00e9 partiellement", color: "bg-amber-500/10 text-amber-400 border-amber-500/20" },
  paye: { label: "Pay\u00e9", color: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20" },
  en_retard: { label: "En retard", color: "bg-rose-500/10 text-rose-400 border-rose-500/20" },
  relance: { label: "Relanc\u00e9", color: "bg-amber-500/10 text-amber-400 border-amber-500/20" },
  litige: { label: "Litige", color: "bg-rose-500/10 text-rose-400 border-rose-500/20" },
};

export const PRIORITIES = {
  basse: { label: "Basse", color: "bg-zinc-500/10 text-zinc-400 border-zinc-500/20" },
  normale: { label: "Normale", color: "bg-sky-500/10 text-sky-400 border-sky-500/20" },
  haute: { label: "Haute", color: "bg-amber-500/10 text-amber-400 border-amber-500/20" },
  urgente: { label: "Urgente", color: "bg-rose-500/10 text-rose-400 border-rose-500/20" },
};

export const formatCurrency = (value) => {
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(value || 0);
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  try {
    return new Date(dateStr).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  } catch {
    return dateStr;
  }
};

export const StatusBadge = ({ status, statusMap }) => {
  const config = statusMap[status] || { label: status, color: "bg-zinc-500/10 text-zinc-400 border-zinc-500/20" };
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-sm text-xs font-medium border ${config.color}`}>
      {config.label}
    </span>
  );
};

export const PriorityBadge = ({ priority }) => {
  const config = PRIORITIES[priority] || PRIORITIES.normale;
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-sm text-xs font-medium border ${config.color}`}>
      {config.label}
    </span>
  );
};
